export enum BankVerificationStatus {
  OPEN = 'OPEN',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  AdvanonChecked = 'ADVANON_CHECKED',
  NOT_NEEDED = 'NOT_NEEDED',
}
